module.exports = __webpack_public_path__ + "img/banner15.50d6c00d.png";